import { useFormik } from "formik";
import * as Yup from "yup";

export const FORM_TYPES = {
  SUPPORT: "support",
  PARTNERSHIP: "partnership",
  MARKETING: "marketing",
};

export const getFormName = (form, siteCountry) => {
  return `contact-${form}` + (form === "support" ? `-${siteCountry}` : "");
};

const useContactForm = (siteCountry, submitForm) => {
  const handleSubmit = async (values, { resetForm }) => {
    if (values.about !== "information") {
      values.informationTopic = "";
    }

    let formName;
    if (
      values.informationTopic === FORM_TYPES.PARTNERSHIP ||
      values.informationTopic === FORM_TYPES.MARKETING
    ) {
      formName = getFormName(values.informationTopic);
    } else {
      formName = getFormName(FORM_TYPES.SUPPORT, siteCountry);
    }

    await submitForm(formName, values, resetForm);
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const formik = useFormik({
    initialValues: {
      fullname: "",
      email: "",
      phone: "",
      about: "-- Select --",
      informationTopic: "-- Select --",
      message: "",
    },
    validationSchema: Yup.object().shape({
      fullname: Yup.string().trim().required("This field is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This field is required"),
      phone: Yup.string()
        .matches(phoneRegExp, "Invalid phone number")
        .required("This field is required"),
      about: Yup.string().required("This field is required"),
      informationTopic: Yup.string().when("about", {
        is: "information",
        then: Yup.string().required("This field is required"),
      }),
      message: Yup.string().trim().required("This field is required"),
    }),
    onSubmit: handleSubmit,
  });

  return formik;
};

export default useContactForm;
